/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCustomerLimits} from '../api'

 export const useQueryGetCustomerLimits = createReactQueryHook('getCustomerLimits', getCustomerLimits)
